import React from 'react'
import ReactDOM from 'react-dom/client'
import posthog from 'posthog-js'
import App from './App.tsx'
import './index.css'
import './i18n' // Initialize i18n

// Initialize PostHog analytics (proxied through ph.tahc.ai to avoid ad blockers)
posthog.init('phc_4hfmwl8ITqMg7CtRyvjlZmOCcPRVtNPN8KYxQ8AasIF', {
  api_host: 'https://ph.tahc.ai',
  person_profiles: 'identified_only',
  ui_host: 'https://us.posthog.com'
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
